module.exports = __webpack_public_path__ + "img/icon_select.ff094b52.svg";